import * as React from "react";

export type FlagIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

export const FlagIcon = React.forwardRef<SVGSVGElement, FlagIconProps>(({ size = 16, className, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      // Let color flow from CSS; don't set fill on <svg> itself
      className={className}
      aria-hidden={props["aria-label"] ? undefined : true}
      {...props}
    >
      <g id="flag">
        <path
          id="Vector"
          d="M13.3333 2.66667H10C10 1.95942 9.71905 1.28115 9.21895 0.781049C8.71885 0.280952 8.04058 0 7.33333 0L2.66667 0C1.95942 0 1.28115 0.280952 0.781049 0.781049C0.280952 1.28115 0 1.95942 0 2.66667L0 15.3333C0 15.5101 0.0702379 15.6797 0.195262 15.8047C0.320286 15.9298 0.489856 16 0.666667 16C0.843478 16 1.01305 15.9298 1.13807 15.8047C1.2631 15.6797 1.33333 15.5101 1.33333 15.3333V8.66667H6.66667C6.66667 9.37391 6.94762 10.0522 7.44772 10.5523C7.94781 11.0524 8.62609 11.3333 9.33333 11.3333H13.3333C14.0406 11.3333 14.7189 11.0524 15.219 10.5523C15.719 10.0522 16 9.37391 16 8.66667V5.33333C16 4.62609 15.719 3.94781 15.219 3.44772C14.7189 2.94762 14.0406 2.66667 13.3333 2.66667ZM1.33333 7.33333V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H7.33333C7.68696 1.33333 8.02609 1.47381 8.27614 1.72386C8.52619 1.97391 8.66667 2.31304 8.66667 2.66667V6C8.66667 6.35362 8.52619 6.69276 8.27614 6.94281C8.02609 7.19286 7.68696 7.33333 7.33333 7.33333H1.33333ZM14.6667 8.66667C14.6667 9.02029 14.5262 9.35943 14.2761 9.60948C14.0261 9.85952 13.687 10 13.3333 10H9.33333C8.97971 10 8.64057 9.85952 8.39052 9.60948C8.14048 9.35943 8 9.02029 8 8.66667V8.572C8.57076 8.42463 9.07661 8.0923 9.43847 7.62695C9.80032 7.16161 9.99779 6.58948 10 6V4H13.3333C13.687 4 14.0261 4.14048 14.2761 4.39052C14.5262 4.64057 14.6667 4.97971 14.6667 5.33333V8.66667Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
});

FlagIcon.displayName = "FlagIcon";
